<template>
  <div>
    <nav-bar/>
    <div id="aboutUs" class="page-padding">
      <div class="container text-center">
        <div class="row aboutUs-txt">
          <div class="col-10 mx-auto">
            <h4 class="title-border-bottom pb-5 mt-8">درباره ما</h4>
              <v-img :src="$replaceHttps(fileUrl)"></v-img>
            <a v-if="link !== null" :href="link">
              <v-btn color="primary" >لینک</v-btn>
            </a>
            <div class="mt-6 px-5" v-html="aboutUsText"></div>
          </div>
        </div>
        <div id="socialNetworks">
          <div class="container">
            <div class="row aboutUs-txt">
              <div class="col-10 mx-auto ">
                <h4 class="title-border-bottom text-center pb-5 mt-8">شبکه های اجتماعی</h4>
                <div class="row px-5">
                  <div class="col-md-2 col-sm-4 col-6 text-center"
                       v-for="item in socialNetworkItems" :key="item.SocialNetworkID">
                    <div v-if="item.IsActive">
                      <a :href="item.Link" target="_blank">
                        <v-img :src="$replaceHttps(item.FileUrl)" :alt=item.Name></v-img>
                        <div class="mt-2">{{ item.Name }}</div>
                        <div class="mt-2" v-html="item.Description"></div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>

  </div>
</template>

<script>
import NavBar from "@/Ticketing/components/navBar";

export default {
  name: "aboutUs",
  components: {NavBar},
  metaInfo() {
    return {
      title: 'تیکتینگ-درباره ما '
    }
  },
  data: () => ({
    aboutUsText: '',
    fileUrl: '',
    socialNetworkItems: [],
    showLoaderDialog: false,
    link: null
  }),
  mounted() {
    this.getData()
    this.getSocial()
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetPage?typePage=1", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = true
            let json = JSON.parse(result)
            console.log(json)
            this.aboutUsText = json.Description
            this.fileUrl = json.FileUrl
            this.link = json.Link
            this.showLoaderDialog = false

          })
          .catch(error => console.log('error', error));
    },
    getSocial() {
      let resStatus = null
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetSocialNetworks", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let json = JSON.parse(result)
              this.socialNetworkItems = json.filter(x => x.IsActive)
            }
            this.showLoaderDialog = false

          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>